module.exports = __webpack_public_path__ + "static/media/Richard M. Nixon - 1960.d2246a82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Richard M. Nixon - 1960.jpg
// module id = 537
// module chunks = 0